import React from 'react';
export function ExpertSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 border-t border-border-light/50" data-id="element-76">
      <div className="max-w-4xl mx-auto text-center" data-id="element-77">
        <h2 className="text-3xl sm:text-4xl font-black text-text-main mb-12 tracking-tight" data-id="element-78">
          Lo que dicen los docentes que ya profesionalizaron su sistema
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-79">
          <div className="bg-bg-alt p-8 rounded-2xl border border-border-light relative" data-id="element-80">
            <span className="absolute -top-4 -left-2 text-5xl text-primary/20 font-serif" data-id="element-81">
              "
            </span>
            <h3 className="text-xl font-bold text-primary mb-4" data-id="element-82">
              Recuperé mis domingos
            </h3>
            <p className="text-text-main text-lg leading-relaxed italic font-medium relative z-10 mb-6" data-id="element-83">
              Antes pasaba mis días libres planificando. Ahora elijo una
              secuencia de los bonos, la aplico y mis alumnos están más felices
              que nunca.
            </p>
            <p className="text-text-sec font-bold" data-id="element-84">— Julián R.</p>
          </div>

          <div className="bg-bg-alt p-8 rounded-2xl border border-border-light relative" data-id="element-85">
            <span className="absolute -top-4 -left-2 text-5xl text-primary/20 font-serif" data-id="element-86">
              "
            </span>
            <h3 className="text-xl font-bold text-primary mb-4" data-id="element-87">
              Mi autoridad técnica se duplicó
            </h3>
            <p className="text-text-main text-lg leading-relaxed italic font-medium relative z-10 mb-6" data-id="element-88">
              Tener los tomos en mi tablet durante la clase me da una seguridad
              increíble. Mis alumnos notan que ahora hay un sistema y una lógica
              detrás de cada movimiento.
            </p>
            <p className="text-text-sec font-bold" data-id="element-89">— Carla M.</p>
          </div>
        </div>
      </div>
    </section>;
}